import React from 'react';
export function Footer() {
  return <footer className="bg-brand-darker py-8 border-t border-white/5 text-center" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <p className="text-gray-500 text-sm" data-id="element-26">
          &copy; {new Date().getFullYear()} The 48-Hour Airbnb Cleanup Protocol.
          All rights reserved.
        </p>
        <div className="mt-4 flex justify-center gap-6 text-xs text-gray-600" data-id="element-27">
          <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-28">
            Terms of Service
          </a>
          <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-29">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-30">
            Contact Support
          </a>
        </div>
      </div>
    </footer>;
}